import { faDoorOpen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { information } from "models/auth"
import { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { BeatLoader } from "react-spinners"
import { toast } from "react-toastify"

interface Props {
    showModal: boolean
    onHide: () => void
}

const LoggedOutModal = ({ showModal, onHide } : Props) => {
    const [logInStatusChecking, setLogInStatusChecking] = useState(false)
    const navigateLogIn = () => window.open(`${window.location.origin}/account/log-in`, "_blank")

    const hide = () => {
      setLogInStatusChecking(true)
      information()
        .then(({ isLoggedIn, isStudent }) => {
          if (isLoggedIn && isStudent) {
            onHide()
          } else {
            navigateLogIn()
          }
        })
        .catch(() => {
          toast.error("There has been an error.")
        })
        .finally(() => setLogInStatusChecking(false))
    }

  return (
    <Modal show={showModal} onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title className="w-100"><FontAwesomeIcon icon={faDoorOpen} /> You have been logged out.</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {logInStatusChecking && <p><BeatLoader /></p>}
        <p>You have been logged out due to inactivity. Please log in again. You can continue working on this tab after logging in.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={navigateLogIn}>
          Log In
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default LoggedOutModal
